export default __webpack_public_path__ + "static/media/2408244.8f56a4c4.webp";